import type { FC } from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'
import type { SelectOption } from '@/components/Select'
import Select from '@/components/Select'
import type { Document } from '@/lib/apollo/query/get-applicant'

import DocumentRadioInput from './DocumentRadioInput'

export type Fields = {
  evidenceFileNames: string[]
  type: string
}

const ConfirmButtons = styled.div`
  display: flex;
  justify-content: end;
`

const Container = styled.div`
  display: grid;
  gap: 30px;
`

const DocumentsListContainer = styled.div`
  display: grid;
  gap: 20px;
  margin-top: 10px;
  overflow-y: scroll;
  max-height: 250px;
`

const idEvidenceTypeSelectOptions: SelectOption<string>[] = [
  { label: 'Select document type', value: '' },
  { label: 'Passport', value: 'Passport' },
  { label: 'Driving Licence', value: 'DrivingLicense' },
  { label: 'Identity Card', value: 'IdentityCard' },
  { label: 'Visa', value: 'Visa' },
  { label: 'Residence Permit', value: 'ResidencePermit' },
  { label: 'Other', value: 'Other' },
]

interface Props {
  documents: Document[]
  draftValues: Fields
  onChangeDraftValues: (fields: Fields) => void
  onCommitValues: (fields: Fields) => void
  onClose: () => void
}

const EditIdEvidenceFields: FC<Props> = ({
  documents,
  draftValues,
  onChangeDraftValues,
  onCommitValues,
  onClose,
}) => {
  const hasDocumentSelected = draftValues.evidenceFileNames.length > 0
  const hasTypeSelected = draftValues.type !== ''
  const isConfirmDisabled = !hasDocumentSelected || !hasTypeSelected

  return (
    <Container>
      <div>
        <div>Select a document to use as proof of ID</div>
        <DocumentsListContainer>
          {documents.length === 0
            ? 'No documents are available for selection'
            : documents.map((document, i) => (
                <DocumentRadioInput
                  key={i}
                  name="idEvidenceDocument"
                  document={document}
                  checked={draftValues.evidenceFileNames.includes(document.fileName)}
                  onChange={() =>
                    onChangeDraftValues({
                      ...draftValues,
                      evidenceFileNames: [document.fileName],
                    })
                  }
                />
              ))}
        </DocumentsListContainer>
      </div>
      <div>
        <Select
          label="Document type"
          options={idEvidenceTypeSelectOptions}
          selectedValue={draftValues.type}
          onSelect={newType => {
            onChangeDraftValues({
              ...draftValues,
              type: newType,
            })
          }}
        />
      </div>
      <ConfirmButtons>
        <Button $alternate onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={isConfirmDisabled} onClick={() => onCommitValues(draftValues)}>
          Confirm
        </Button>
      </ConfirmButtons>
    </Container>
  )
}

export default EditIdEvidenceFields
